import { css } from '@emotion/css/macro';
import StyleConstants from '../../../../common/StyleConstants';

const style = css`
  max-width: ${StyleConstants.MAX_WIDTH}px;
  width: 100%;
  padding: 40px 0 0;
  p {
    font-size: 42px;
    margin: 0 31px 13px 31px;
  }
  h1 {
    font-size: 22px;
    line-height: 1.36;
    letter-spacing: -0.82px;
    color: #4855d1;
    margin: 0 0 37px 27px;
  }
  b {
    font-weight: bold;
  }
  h2 {
    font-size: 22px;
    line-height: 1.36;
    letter-spacing: -0.82px;
    color: #42607f;
    margin: 0 0 9px 27px;
  }
  h3 {
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: -0.6px;
    color: #757575;
    margin: 0 27px 48px 27px;
    word-break: keep-all;
    b {
      color: #4a4a4a;
    }
  }
  img {
    display: block;
    width: 100%;
    left: 0;
    margin: 40px auto 80px;
  }
`;
const chatStyle = css`
  margin: 0 27px;
  img {
    width: 100%;
  }
`;
const chatWapper = css`
  display: block;
  left: 0;
  margin: 0 auto;
`;
const imgWrapper = css`
  padding: 0 27px;
`;
export default function DescView() {
  return (
    <section className={style}>
      <p>💪🏼</p>
      <h1>
        <b>도깃으로 교육</b>하면
        <br />
        <b>성공할 수 밖에 없는 이유</b>
      </h1>
      <article>
        <h2>
          따라하기 쉽게 설계된,
          <br />
          <b>실습 위주의 교육 프로그램</b>
        </h2>
        <h3>
          실습이 없는 이론 위주의 강아지 훈련은 아무 의미 없으니까!{' '}
          <u>
            <b>쉽게 따라할 수 있도록 단계별</b>
          </u>
          로 차근히 알려드려요.
        </h3>
        <div className={imgWrapper}>
          <img src='//static.dogmate.co.kr/dogit/landing-v3/program-detail/dogit-v3-step1.png' />
        </div>
      </article>
      <article>
        <h2>
          내 강아지의 반응에 따라
          <br />
          보여지는 <b>맞춤형 커리큘럼</b>
        </h2>
        <h3>
          같은 훈련이라도 강아지마다 다르게 반응해요.{' '}
          <u>
            <b>내 강아지 반응에 맞춘 맞춤형 커리큘럼</b>
          </u>
          을 받아보세요.
        </h3>
        <div className={imgWrapper}>
          <img src='//static.dogmate.co.kr/dogit/landing-v3/program-detail/dogit-v3-mission-noti.png' />
        </div>
      </article>
      <article>
        <h2>
          내가 할 수 있는{' '}
          <b>
            때와 장소에
            <br />
            맞는 훈련 추천
          </b>
        </h2>
        <h3>
          <u>
            <b>시간, 장소, 날씨 등 상황에 맞는</b>
          </u>
          &nbsp;훈련을 진행해보세요.
        </h3>
        <div className={imgWrapper}>
          <img src='//static.dogmate.co.kr/dogit/landing-v3/program-detail/dogit-v3-mission-start.png' />
        </div>
      </article>
      <article>
        <h2>
          훈련 중 막막한 부분은
          <br />
          <b>전문가와 일대일 상담</b>
        </h2>
        <h3>
          강아지가 잘 따라오지 못하는 부분은 언제든 전문 매니저에게 물어보세요!&nbsp;
          <u>
            <b>해결 방법을 자세히 알려드려요.</b>
          </u>
        </h3>
        <div className={chatWapper}>
          <article className={chatStyle}>
            <img src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-chat.png' />
          </article>
        </div>
      </article>
    </section>
  );
}
